const industryContent = window.__industryContent ?? {};
const wordReplacements = industryContent.words ?? {};
const contentReplacements = industryContent.content ?? {};

export const getIndustryWord = (input) => {
  const isCapitalised = /^[A-Z]/.test(input);

  const translated = wordReplacements[input.toLowerCase()] ?? input;

  if (isCapitalised) {
    return translated.charAt(0).toUpperCase() + translated.slice(1);
  }

  return translated;
};

export const getIndustryContent = (key) => contentReplacements[key] ?? key;
